<template>
    <div class="row">
        <div class="col-xl-8 col-lg-8 col-md-10 col-sm-10 mx-auto form p-1">
            <div v-if="payload" class="alert alert-success" role="alert">
                Дані успішно збережені!
            </div>
            <div v-if="error" class="alert alert-danger" role="alert">
                Помилка при збереженні даних
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="form-group">
                        <label>
                            <strong>ID</strong>
                        </label>
                        <input
                            name="uid"
                            type="text"
                            v-model="model.uid"
                            class="form-control"
                            disabled
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Статус</strong>
                        </label>
                        <select class="form-control" v-model="model.status">
                            <option :value="null" disabled>-</option>
                            <option value="новый">новый</option>
                            <option value="в работе">в работе</option>
                            <option value="завершен">завершен</option>
                        </select>
                    </div>
                    <div class="form-group mt-2 mb-1">
                        <a :href="model.file" target="_blank" class="file">
                            {{ model.file }} <i class="pi pi-file"></i>
                        </a>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Ответственный региональный менеджер</strong>
                        </label>
                        <input
                            name="manager"
                            type="text"
                            v-model="model.manager"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Регион (Город)</strong>
                        </label>
                        <input
                            name="region"
                            type="text"
                            v-model="model.region"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Коментар адміна</strong>
                        </label>
                        <textarea
                            name="name"
                            type="text"
                            v-model="model.admin_comment"
                            class="form-control"
                        ></textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Організація *</strong>
                        </label>
                        <input
                            name="org_name"
                            type="text"
                            v-model="model.org_name"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Контактна особа *</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.name"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Номер телефону *</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.phone"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Електронна пошта *</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.email"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Найменування та адреса *</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.address"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Номінальний струм, А</strong>
                        </label>
                        <input
                            name="power_a"
                            type="text"
                            v-model="model.power_a"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Матеріал провідника</strong>
                        </label>
                        <input
                            name="conductor_material"
                            type="text"
                            v-model="model.conductor_material"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Виконання шинопроводу</strong>
                        </label>
                        <input
                            name="execution"
                            type="text"
                            v-model="model.execution"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Ступінь захисту</strong>
                        </label>
                        <input
                            name="protection_degree"
                            type="text"
                            v-model="model.protection_degree"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Тип шинопроводу</strong>
                        </label>
                        <textarea
                            name="type"
                            type="text"
                            v-model="model.type"
                            class="form-control"
                        ></textarea>
                    </div>
                    
                    <div class="form-group">
                        <label>
                            <strong>Додаткова інформація</strong>
                        </label>
                        <textarea
                            name="name"
                            type="text"
                            v-model="model.additional_information"
                            class="form-control"
                        ></textarea>
                    </div>
                    <div class="form-group mt-2 mb-1">
                        <label>
                            <strong>Посилання на гугл диск</strong>
                        </label>
                        <br>
                        <a v-if="model.google_drive_link" :href="model.google_drive_link">{{ model.google_drive_link }}</a>
                        <span v-else>-</span>
                    </div>
                </div>
            </div>
            <div class="text-right">
                <template v-if="model.id">
                    <delete-confirmation
                        :route-path="route('api.busbar.delete', {form: model.id})"
                        :redirect-path="route('busbar.list')"
                        :title="'Удаление'"
                        class="btn btn-danger mr-1 text-white"
                    >Удалить</delete-confirmation>
                </template>
                <button
                    type="submit"
                    class="btn btn-primary"
                    @click.prevent="update"
                >
                    Сохранить
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Row from "primevue/row";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import AutoComplete from "primevue/autocomplete";
import axios from "axios";
import DeleteConfirmation from '../mixins/components/delete.vue';
import "bootstrap/dist/css/bootstrap.min.css"

export default {
    props: {
        model: {
            type: Object,
            required: false,
        },
        files: {
            type: Object,
            required: false,
        }
    },
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Row,
        ColumnGroup,
        Button,
        InputText,
        InputNumber,
        AutoComplete,
        DeleteConfirmation,
    },
    data() {
        return {
            errors: {},
            payload: false,
            error: false,
        }
    },
    mounted() {
        console.log(this.model);
    },
    methods: {
        update() {
            this.payload = false;
            this.error = false;
            axios.post(this.route('api.busbar.update', {form: this.model.id}), this.model)
                .then((result) => {
                    this.payload = true;
                    window.scroll(0, 0);
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        }
    }
}
</script>

<style scoped>
.file .pi {
    font-size: 24px;
}
</style>